module.exports = __webpack_public_path__ + "static/media/Icon-arrow-gray.a4c10bcf.png";